(function () {
  'use strict';

  var revealObserver;
  var curtains = [];
  var ticking = false;

  function observeReveals(scope) {
    var root = scope || document;
    var elements = root.querySelectorAll('[data-dodi-reveal]:not(.is-visible)');

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) { element.classList.add('is-visible'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }

    elements.forEach(function (element) { revealObserver.observe(element); });
  }

  function collectCurtains() {
    curtains = Array.prototype.slice.call(document.querySelectorAll('[data-dodi-curtain-scroll]'));
  }

  function updateCurtains() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    curtains.forEach(function (wrapper) {
      var stage = wrapper.querySelector('.dodi-curtain');
      if (!stage) return;

      var rect = wrapper.getBoundingClientRect();
      var compactCurtain = window.matchMedia('(max-width: 749px)').matches;
      var travel = compactCurtain
        ? Math.max(viewportHeight * 1.05, 1)
        : Math.max(wrapper.offsetHeight - stage.offsetHeight, 1);
      var rawProgress = compactCurtain
        ? ((viewportHeight * 0.88) - rect.top) / travel
        : -rect.top / travel;
      var progress = reduceMotion ? 1 : Math.max(0, Math.min(1, rawProgress));
      stage.style.setProperty('--dodi-curtain-progress', progress.toFixed(4));
      stage.classList.toggle('is-opening', progress > 0.02 && progress < 0.98);
      stage.classList.toggle('is-open', progress >= 0.98);
    });

    ticking = false;
  }

  function requestCurtainUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateCurtains);
  }

  function initTrustBadgeDots(scope) {
    var root = scope || document;
    var sections = root.matches && root.matches('.dodi-trust-badges')
      ? [root]
      : root.querySelectorAll('.dodi-trust-badges');

    Array.prototype.forEach.call(sections, function (section) {
      if (section.dataset.dodiDotsReady === 'true') return;

      var grid = section.querySelector('.dodi-trust-badges__grid');
      var cards = Array.prototype.slice.call(section.querySelectorAll('.dodi-trust-badge'));
      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-dodi-trust-dot]'));
      if (!grid || cards.length < 2 || dots.length !== cards.length) return;

      section.dataset.dodiDotsReady = 'true';
      var dotTicking = false;

      function setActive(index) {
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function updateActiveDot() {
        var gridCenter = grid.getBoundingClientRect().left + (grid.clientWidth / 2);
        var closestIndex = 0;
        var closestDistance = Infinity;

        cards.forEach(function (card, index) {
          var rect = card.getBoundingClientRect();
          var distance = Math.abs((rect.left + rect.width / 2) - gridCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        setActive(closestIndex);
        dotTicking = false;
      }

      grid.addEventListener('scroll', function () {
        if (dotTicking) return;
        dotTicking = true;
        window.requestAnimationFrame(updateActiveDot);
      }, { passive: true });

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          grid.scrollTo({ left: cards[index].offsetLeft - grid.offsetLeft, behavior: 'smooth' });
          setActive(index);
        });
      });

      updateActiveDot();
    });
  }

  function init(scope) {
    observeReveals(scope);
    collectCurtains();
    updateCurtains();
    initTrustBadgeDots(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.addEventListener('scroll', requestCurtainUpdate, { passive: true });
  window.addEventListener('resize', requestCurtainUpdate);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
